import { Link } from "react-router-dom";
import "../../../styles/transportPublicPages.css";

const TransportPublicLayout = ({ title, children }) => (
  <div className="transport-public-layout">
    <header className="transport-public-header">
      <div>
        <Link to="/">Midpoint</Link>
        <div className="transport-public-disclaimer">{title || "Mobility intelligence"}</div>
      </div>
      <nav>
        <Link to="/transport/community-reports">Community reports</Link>
      </nav>
    </header>
    <main className="transport-public-main">{children}</main>
  </div>
);

export default TransportPublicLayout;
